export default function format(sousType) {
    if ("SIMPLE" === sousType) {
        return "Simple"
    } else if ("STATUTS" === sousType) {
        return "Statuts"
    } else if ("DENOMINATION" === sousType) {
        return "Dénomination"
    } else if ("ADRESSE" === sousType) {
        return "Adresse du siège"
    } else if ("ADMINISTRATIF" === sousType) {
        return "Administratif"
    } else if ("MEMBRES" === sousType) {
        return "Membres"
    } else if ("JUDICIAIRE" === sousType) {
        return "Judiciaire"
    } else if ("ASSOCIATION" === sousType) {
        return "Demande de l'association"
    } else if ("DISSOLUTION_79_1" === sousType) {
        return "Dissolution article 79-1"
    } else if ("TRANSFERT_JURIDICTION" === sousType) {
        return "Transfert de siège"
    } else if ("CREATION_SUITE_TRANSFERT" === sousType) {
        return "Création suite à transfert"
    } else if ("FUSION" === sousType) {
        return "Fusion";
    } else if ("SANS_SOUS_TYPES" === sousType) {
        return "Inclure les requêtes sans sous-types"
    }

    return null;
}

export function sousTypeRequeteSelectItems() {
    return [
        "SANS_SOUS_TYPES",
        "SIMPLE",
        "STATUTS",
        "DENOMINATION",
        "ADRESSE",
        "ADMINISTRATIF",
        "MEMBRES",
        "JUDICIAIRE",
        "ASSOCIATION",
        "DISSOLUTION_79_1",
        "TRANSFERT_JURIDICTION",
        "CREATION_SUITE_TRANSFERT",
        "FUSION"
    ].map(value => ({ value, text: format(value) }));
}
